<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="new_item"
    :can-delete="false"
    @escape="escape"
    @save="save"
    @remove="remove"
  >
    <template v-slot:editform>
      <edit-form
        v-if="!fix_item"
        :plane-fault-report="edited_item"
      />
      <edit-form-fix
        v-if="edited_item.plane && fix_item"
        :plane-fault-report="edited_item"
      />
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'PlaneFaultReportEdit',
    components: {
      EditForm: () => import('@/layouts/default/edit/PlaneFaultReport'),
      EditFormFix: () => import('@/layouts/default/edit/PlaneFaultReportFix'),
    },
    data: function () {
      return {
        icon: '$plane_fault_reports',
        title: 'plane_fault_report_data',
        new_item: true,
        fix_item: false,
        edited_item_id: -1,
        edited_item: {},
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    mounted () {
      this.new_item = this.$route.params.edit_type === 'new'
      this.fix_item = this.$route.params.edit_type === 'fix'
      this.fetch()
    },
    methods: {
      fetchEditedItem: call('planeFaultReport/fetch'),
      insertEditedItem: call('planeFaultReport/insert'),
      updateEditedItem: call('planeFaultReport/update'),
      fixEditedItem: call('planeFaultReport/fix'),
      deleteEditedItem: call('planeFaultReport/delete'),
      async fetch () {
        this.loading = true
        if (!this.new_item) {
          this.edited_item_id = parseInt(this.$route.params.id)
          await this.fetchEditedItem(
            { id: this.edited_item_id },
          ).then(response => {
            this.edited_item = response
            this.edited_item.maintenance_operator_id = this.profile.user_id
            this.loading = false
          })
        } else {
          this.edited_item = {
            created_operator_id: this.profile.user_id,
          }
          console.log(this.edited_item)
        }
      },
      async save () {
        this.loading = true
        if (this.new_item) {
          await this.insertEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        } else if (this.fix_item) {
          await this.fixEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        } else {
          await this.updateEditedItem(
            this.edited_item,
          ).then(response => {
            this.saved = true
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        }
      },
      async remove () {
        this.loading = true
        await this.deleteEditedItem(
          { id: this.edited_item_id },
        ).then(response => {
          this.saved = true
          this.escape()
        }).catch(e => {
          this.loading = false
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      escape () {
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
    /* beforeRouteLeave (to, from, next) {
      console.log(this.saved)
      if (!this.saved) {
        const answer = window.confirm(this.$t('edit_leave_without_save'))
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    }, */
  }
</script>
